import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4df8cbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-progress" }
const _hoisted_2 = ["aria-label", "aria-valuenow", "aria-valuetext"]
const _hoisted_3 = {
  class: "upload-progress__label",
  "aria-hidden": "true"
}

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadProgressBar',
  props: {
    percent: null,
    label: { default: '' }
  },
  setup(__props: any, { expose }) {



// Presentational only: this component does not know about uploads or the store. The parent
// owns when to move focus here; this just exposes a way to do it.
const track = ref<HTMLElement | null>(null)

function focus() {
    track.value?.focus()
}

expose({ focus })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "upload-progress__track",
      ref_key: "track",
      ref: track,
      role: "progressbar",
      tabindex: "-1",
      "aria-label": __props.label,
      "aria-valuenow": __props.percent,
      "aria-valuetext": `${__props.percent}%`,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, [
      _createElementVNode("div", {
        class: "upload-progress__fill",
        style: _normalizeStyle({ width: `${ __props.percent }%` })
      }, null, 4)
    ], 8, _hoisted_2),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.percent) + "%", 1)
  ]))
}
}

})